import React,{Component} from 'react';
import './AdminPendingCourier.css';
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import assignblue from '../../../image/assignblue.svg'
import searchicon from '../../../image/searchicon.svg'
import {Link} from 'react-router-dom';
import axios from 'axios'
import {LinkAPI} from '../../../API/API'
import HandleRes from '../../Components/HandleRes/HandleRes';
import barcode from '../../../image/bar-code.svg'

var moment = require('moment');
 
class AdminPendingCourier extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            statusfilter:0,
            collect:-1,
            currentPage: 1,
            ordersPerPage: 8,
            networkError: false,
            errordatamessage: false,
            hasError: false,
        };
        this.handleClick = this.handleClick.bind(this);

       this.getcouriers()
                } 

                getcouriers=()=>{
                    const Token =localStorage.getItem("AdminTokenKayn")
                    axios.get(`${LinkAPI}/api/admin/getcouriers`,{
                        headers:{
                          Authorization:`${Token}`,
                          status:0
                        }
                      }).then(res =>{
                        this.setState({
                            data: res.data.reverse(),
                            dataorders: res.data.reverse(),
                            networkError: false,
                            errordatamessage: false,
                            hasError: false,
                          })
                          }).catch(error=>{
                          if (!error.response) {
                            this.setState({
                                networkError: true
                            })
                        } else if (error.response.status === 402) {
                            window.location.replace("/Admin/SignIn");
                        } else if (error.response.data.message) {
                            this.setState({
                                errordatamessage: true,
                                errordatamessagetext: error.response.data.message,
                                failedreasonerror: '',
                
                            })
                        } else {
                            this.setState({
                                hasError: true,
                            })
                        }
                          })
                }
                handleClick(event) {
                    this.setState({
                      currentPage: Number(event.target.value)
                    });
                  }
                 
                handleChange = event => {
                    this.setState({
                        statusfilter  : event.target.value
                    });
                };
                
                confirmCourier= (x)  => {
                    const Token = localStorage.getItem("AdminTokenKayn")
                    const isValid = true;
                    if (isValid) {
                        axios.put(`${LinkAPI}/api/admin/editcourier`, {
                            courier_id: x,
                            update: {
                                status: 1,
                            }
                        }, {
                            headers: {
                                Authorization: `${Token}`
                            }
                        }).then(res => {
                            this.setState({
                                doneconfirm: true,
                                networkError: false,
                                errordatamessage: false,
                                errordatamessagetext: '',
                                hasError: false,
                            })
                            this.getcouriers()
                            setTimeout(() => {
                                this.setState({
                                    doneconfirm: false
                                })
                            }, 2000);
                        }).catch(error => {
                            if (!error.response) {
                                this.setState({
                                    networkError: true
                                })
                            } else if (error.response.status === 402) {
                                window.location.replace("/Admin/SignIn");
                            } else if (error.response.data.message) {
                                this.setState({
                                    titleError: '',
                                    onlineError: '',
                                    errordatamessage: true,
                                    errordatamessagetext: error.response.data.message
                                })
                            } else {
                                this.setState({
                                    hasError: true,
                                })
                            }
                        })
                    }
                } 
                BlockCourier = (x) => {
                    const Token = localStorage.getItem("AdminTokenKayn")
                    const isValid = true;
                    if (isValid) {
                        axios.put(`${LinkAPI}/api/admin/editcourier`, {
                            courier_id: x,
                            update: {
                                status: 2,
                            }
                        }, {
                            headers: {
                                Authorization: `${Token}`
                            }
                        }).then(res => {
                            this.setState({
                                doneblock: true,
                                networkError: false,
                                errordatamessage: false,
                                errordatamessagetext: '',
                                hasError: false,
                            })
                            this.getcouriers()
                            setTimeout(() => {
                                this.setState({
                                    doneblock: false
                                })
                            }, 2000);
                        }).catch(error => {
                            if (!error.response) {
                                this.setState({
                                    networkError: true
                                })
                            } else if (error.response.status === 402) {
                                window.location.replace("/Admin/SignIn");
                            } else if (error.response.data.message) {
                                this.setState({
                                    titleError: '',
                                    onlineError: '',
                                    errordatamessage: true,
                                    errordatamessagetext: error.response.data.message
                                })
                            } else {
                                this.setState({
                                    hasError: true,
                                })
                            }
                        })
                    }
                } 
                
    render(){
        
     
        let  filteredContants = this.state.data.filter(
            (contact)=>{
                return contact.status.toString().indexOf(this.state.statusfilter.toString())!==-1;
            }
        )

        
        // let filteredContants = filteredContantsname.concat(filteredContantsphone);
        const {  currentPage, ordersPerPage } = this.state;
        // Logic for displaying current todos
        const indexOfLastorders = currentPage * ordersPerPage;
        const indexOfFirstorders = indexOfLastorders - ordersPerPage;
        const currentdataorders = filteredContants.slice(indexOfFirstorders, indexOfLastorders);
        const renderdataorders = currentdataorders.map((x, i) => {
            const block=(x.status!==2?<button type="button" className="btn  mt-2 btn-outline-danger mx-md-3 badge-pill"onClick={()=>this.BlockCourier(x._id)}>BLOCK</button>:'')
                                    return       <tr key={i}>
                                    <td>{x.name}</td>
                                    <td>{x.phone}</td> 
                                    <td>{block}
                                    <button type="button" className="btn mt-2 mx-md-3 btn-outline-success badge-pill" onClick={()=>this.confirmCourier(x._id)}>CONFIRM</button></td>
                                    </tr>;
                                    });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(filteredContants.length / ordersPerPage); i++) {
          pageNumbers.push(i);
        }
        const renderPageNumbers = pageNumbers.map(number => {
            return ( <option key={number} value={number} > {number} </option> );
          });
       
       
        return(
            <div className="AppEN container-fluid px-0">
                    <div className="row   mx-0">
                        <div className="col-md-1 px-0 ">
                        <NabarAdmin/>
                        </div>
                        <div className="Orders Admin col-md-11 px-lg-5 " >
                        <AdminHeaderTool/>
                            <h3 className=" fontsize9 my-2">Orders</h3>
                            <div className="filter px-4 row"> 
                                <p className="fontsize11 font-weight-bold mt-2 col-lg-1 col-md-2">View</p>
                                    <div className="col-lg-2 col-md-5">
                                        <div className="form-group  ">
                                        <select id="inputState" className="form-control  badge-pill  text-muted" onClick={this.handleChange}>
                                                <option value="0" >Pending</option>
                                                <option value="2">Blocked</option>

                                            </select>
                                        </div>
                                    </div>
                                
                               
                            </div>
                        
                        <div className="allorder shadow  p-3 ">
                            <div className="row ">
                           <p className="col-6 mt-3 fontsize4">All Orders</p>
                           
                            </div>
                            <table className="table  table-bordered table-sm">
                                <thead className="thead-light fontsize12 text-muted ">
                                    <tr>                
                                        <th >name</th>
                                        <th>phone</th>
                                        <th >status</th>
                                    </tr>
                                </thead>
                                <tbody className="fontsize11 bg-white">
                                    
                                    {renderdataorders}
                                    
                                </tbody>
                               

                            </table>
                           
                                
                            <div className="row px-4 d-flex bd-highlight mb-3">
                                <div className="col mr-auto p-2 bd-highlight">
                                    <p>Total: {filteredContants.length} order</p>
                                </div>
                                <div className="px-lg-5 p-2 bd-highligh">
                                        <div className="form-group  ">
                                            <select onChange={this.handleClick} id="inputState" className=" px-5 form-control  badge-pill  text-muted">
                                            {(renderPageNumbers.length===0?<option value="1"> 1 </option>:renderPageNumbers)}
                                            </select>
                                        </div>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.doneconfirm ? <HandleRes title="Courier status has been changed" stylecss="alert-success" /> : '')}
                {(this.state.doneblock ? <HandleRes title="Courier status has been changed" stylecss="alert-success" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
{(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
{(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default AdminPendingCourier;